{
  "title": {
    "connectWallet": "Connect wallet",
    "connecting": "Connecting",
    "selectWallet": "Select a wallet",
    "selectWalletWithChain": "Select {{chainLabel}} wallet",
    "selectEcosystem": "Select an ecosystem",
    "waitingForWallet": "Waiting for {{walletName}}",
    "availableWalletsNotFound": "Available wallets not found"
  },
  "message": {
    "connecting": "Click connect in your wallet popup. Don't see your wallet? Check your other browser windows.",
    "multipleEcosystems": "{{walletName}} supports multiple chain ecosystems. Select which one to connect to.",
    "availableWalletsNotFound": "No compatible wallet extensions detected. Please install a supported wallet and refresh the page. If already installed, ensure it's enabled and compatible, or contact support."
  },
  "tags": {
    "connected": "Connected",
    "multichain": "Multichain",
    "installed": "Installed",
    "qrCode": "QR Code",
    "getStarted": "Get Started"
  }
}
